import ReactMarkdown from 'react-markdown';
import { Column, Row } from '@simplywallst/ui-core';
import {
  StoryContainerRow,
  StoryHeader,
  StoryContentRow,
  StoryContentText,
  StyledStoryContentReactMarkdown,
  Timeline,
  TimelineHeader,
  StyledTimelineContentReactMarkdown,
  StyledDateReactMarkdown,
} from './styled';
import { OneColumnExpanded } from '../../styled';

interface Props {
  title?: string;
  markdownContent: string[];
  timelineTitle?: string;
  timeline: string[];
}

export const Story = ({
  title,
  markdownContent,
  timeline,
  timelineTitle,
}: Props) => {
  return (
    <StoryContainerRow justifyContent="center">
      <OneColumnExpanded>
        <StoryHeader data-cy-id="story">
          <h2>{title}</h2>
        </StoryHeader>
        <StoryContentRow>
          <Column colMd={7} colLg={8} displayFlex alignItem="center">
            <StoryContentText>
              <StyledStoryContentReactMarkdown>
                <ReactMarkdown source={markdownContent[0]} />
              </StyledStoryContentReactMarkdown>
              <StyledStoryContentReactMarkdown>
                <ReactMarkdown source={markdownContent[1]} />
              </StyledStoryContentReactMarkdown>
              <StyledStoryContentReactMarkdown>
                <ReactMarkdown source={markdownContent[2]} />
              </StyledStoryContentReactMarkdown>
              <StyledStoryContentReactMarkdown>
                <ReactMarkdown source={markdownContent[3]} />
              </StyledStoryContentReactMarkdown>
              <StyledStoryContentReactMarkdown>
                <ReactMarkdown source={markdownContent[4]} />
              </StyledStoryContentReactMarkdown>
            </StoryContentText>
          </Column>

          <Column colMd={5} colLg={4}>
            <TimelineHeader>{timelineTitle}</TimelineHeader>
            <Timeline>
              <Row noWrap>
                <Column col={2}>
                  <StyledDateReactMarkdown>
                    <ReactMarkdown source={timeline[0]} />
                  </StyledDateReactMarkdown>
                </Column>
                <Column col={10}>
                  <StyledTimelineContentReactMarkdown>
                    <ReactMarkdown source={timeline[1]} />
                  </StyledTimelineContentReactMarkdown>
                </Column>
              </Row>
            </Timeline>
          </Column>
        </StoryContentRow>
      </OneColumnExpanded>
    </StoryContainerRow>
  );
};
